import React from 'react';
import SaveButton from '../../../../components/SaveButton/SaveButton';
import {checkIfResidencePageIsValid} from '../../../../validation/FormValidation';
import {updateResidenceEditMode} from '../../../../redux/app-state-slice';
import ResidenceInfoSection from '../../PrequalForm/ResidenceInfoSection/ResidenceInfoSection';

function ResidenceInfoReview({customerData, dispatch, appConfig}) {
  return (
    <>
      {!customerData.cardEditFlags.residenceEditMode.value && (
        <div>
          <div
            className={`prequal--web--review-page-padding-20 ${
              customerData.isDealerHostApplication.value ? 'prequal--wc--review-page-item-container' : ''
            }`}
          >
            <label className='prequal--web--label-fomo'>Address</label>
            <p className='prequal--web--display-address-text-fomo'>
              {appConfig.modalUpdateFlag ? (
                <span>{customerData.streetAddress.value}</span>
              ) : (
                <span>
                  {customerData.streetAddress.value}, {customerData.apartment.value}{' '}
                </span>
              )}
            </p>
            <p className='prequal--web--display-text-fomo'>
              <span>
                {customerData.city.value},{customerData.stateOrProvince.value} {customerData.postalCode.value}
              </span>
            </p>
          </div>
        </div>
      )}
      {customerData.cardEditFlags.residenceEditMode.value && (
        <>
          <div
            className={`prequal--web--review-page-padding-20 ${
              customerData.isDealerHostApplication.value ? 'prequal--wc--review-page-item-container' : ''
            }`}
          />
          <ResidenceInfoSection dispatch={dispatch} customerData={customerData} appConfig={appConfig} />
          <SaveButton
            onClickHandler={() => (checkIfResidencePageIsValid(customerData) ? dispatch(updateResidenceEditMode(false)) : null)}
            isFieldValid={checkIfResidencePageIsValid(customerData)}
          />
        </>
      )}
    </>
  );
}

export default ResidenceInfoReview;
